const Todo = ({ todo, onCompleted, onDelete, onEdit }) => {
	return (
		<div className="todo">
			<div
				onClick={onCompleted}
				className={`textTodo ${todo.isCompleted ? "completed" : ""}`}
			>
				<input type="checkbox" checked={todo.isCompleted} />
				<span>{todo.text}</span>
			</div>
			<div className="todoBtns">
				<button onClick={onEdit} className="btn">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						fill="none"
						viewBox="0 0 24 24"
						stroke-width="1.5"
						stroke="currentColor"
						className="icon"
					>
						<path
							stroke-linecap="round"
							stroke-linejoin="round"
							d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L6.832 19.82a4.5 4.5 0 01-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 011.13-1.897L16.863 4.487zm0 0L19.5 7.125"
						/>
					</svg>
				</button>
				<button onClick={onDelete} className="btn remove">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						fill="none"
						viewBox="0 0 24 24"
						strokeWidth={1.5}
						stroke="currentColor"
						className="icon"
					>
						<path
							strokeLinecap="round"
							strokeLinejoin="round"
							d="M6 18L18 6M6 6l12 12"
						/>
					</svg>
				</button>
			</div>
		</div>
	);
};

export default Todo;
